import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { Button } from '../../../../components/button/Button';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { CreditHoldAgingReport } from '../../../../modules/ordering/components/CreditHoldAgingReport';
import { AgingReport } from '../../../../modules/ordering/models/credit-hold-aging-report';
import { DocumentAgingReportExport } from '../../../../modules/ordering/models/document-aging-report';
import { PageNames } from '../../../../utils/app-constants';

interface IProps {
    report: AgingReport | undefined;
    dealerId: string
}

export const AgingReportScene = (props: IProps) => {

    const dispatch = useDispatch();
    /**
     * Make a request to export the aging report to Excel  
     */
    const exportAgingReport = async () => {
        const req = new DocumentAgingReportExport(props.dealerId);
        dispatch(getDocumentHelper(req));
    }

    return props.report ?
        <PageContent pageName={PageNames.SUPPORT_DEALERS_DETAILS}>
            <PageBody>
                <div className="aging-report-container">
                <CreditHoldAgingReport report={props.report} />
                </div>
                <div>
                    <div className='aging-report-export-container'>
            <Button
                text="Export"
                    classes="attention aging-report-export"
                testID="aging-report"
                disable={props.report && props.report.invoices.length > 0 ? false : true}
                onBtnClick={exportAgingReport}
            />
            </div>
            </div>
            </PageBody>
        </PageContent> : null;
};
